import { render, staticRenderFns } from "./statementAfter.vue?vue&type=template&id=1a8bad3d&scoped=true&"
import script from "./statementAfter.vue?vue&type=script&lang=js&"
export * from "./statementAfter.vue?vue&type=script&lang=js&"
import style0 from "./statementAfter.vue?vue&type=style&index=0&id=1a8bad3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bad3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8bad3d')) {
      api.createRecord('1a8bad3d', component.options)
    } else {
      api.reload('1a8bad3d', component.options)
    }
    module.hot.accept("./statementAfter.vue?vue&type=template&id=1a8bad3d&scoped=true&", function () {
      api.rerender('1a8bad3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statementAfter.vue"
export default component.exports